export const options = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 0,
  desiredAccuracy: 0,
  frequency: 1,
}



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/WatchPosition/WatchPositionComponent/options.js